import { Error, BackToLogin } from '@mgm/common/components';
import { Crisp } from 'crisp-sdk-web';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Page } from '../components/Page';

const ErrorPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'warning', 'welcome']);

  return (
    <Error
      PageWrapper={Page}
      locale={{
        serverError: t('serverError', { ns: 'warning' }),
        errorDescription: t('thereIsAnError', { ns: 'warning' }),
        contactSupport: t('contactSupport'),
        tryAgain: t('tryAgain', { ns: 'warning' }),
      }}
      onTryAgain={() => navigate(-1)}
      onContactSupport={() => Crisp.chat.open()}
      BackToLoginComponent={(
        <BackToLogin
          NavLinkComponent={NavLink as never}
          btnText={t('backToLogin', { ns: 'welcome' })}
        />
      )}
    />
  );
};
export default ErrorPage;
